import { loadMessages } from './chatStore.ts'
import { getPinnedAt, isChatPinned } from './pinnedChatsStore.ts'
import type { ZionContact } from './pairingStore.ts'

/** Contatto arricchito per lista home (pin + ultimo messaggio). */
export type ChatListItem = ZionContact & {
  isPinned?: boolean
  pinnedAt?: number
  lastMessageTimestamp?: number
  createdAt?: number
}

export function sortChatList<T extends ChatListItem>(chats: T[]): T[] {
  return [...chats].sort((a, b) => {
    if (a.isPinned && !b.isPinned) return -1
    if (!a.isPinned && b.isPinned) return 1
    if (a.isPinned && b.isPinned) {
      return (b.pinnedAt || 0) - (a.pinnedAt || 0)
    }
    const timeA = a.lastMessageTimestamp || a.createdAt || a.pairedAt || 0
    const timeB = b.lastMessageTimestamp || b.createdAt || b.pairedAt || 0
    return timeB - timeA
  })
}

export async function lastMessageTimestampForContact(
  contactId: string,
  sessionToken?: string,
): Promise<number> {
  let last = 0
  const primary = await loadMessages(contactId)
  if (primary.length) last = Math.max(last, primary[primary.length - 1]!.timestamp || 0)
  const sess = sessionToken?.trim()
  if (sess && sess.toLowerCase() !== contactId.trim().toLowerCase()) {
    const bySess = await loadMessages(sess)
    if (bySess.length) last = Math.max(last, bySess[bySess.length - 1]!.timestamp || 0)
  }
  return last
}

export async function enrichContactsForChatList(contacts: ZionContact[]): Promise<ChatListItem[]> {
  const enriched = await Promise.all(
    contacts.map(async (c) => {
      const lastMessageTimestamp = await lastMessageTimestampForContact(c.contactId, c.sessionToken)
      const pinned = isChatPinned(c.contactId)
      return {
        ...c,
        isPinned: pinned,
        pinnedAt: pinned ? getPinnedAt(c.contactId) : undefined,
        lastMessageTimestamp,
        createdAt: c.pairedAt,
      } satisfies ChatListItem
    }),
  )
  return sortChatList(enriched)
}
